import { Component, OnInit, Input } from '@angular/core';
import { UserActivityService } from '../../../shared/services/activity/user-activity.service';
import { UserActivityLog } from '../../../shared/models/user-activity.model';

@Component({
  selector: 'app-user-detail-activity',
  templateUrl: './user-detail-activity.component.html',
  styleUrls: ['./user-detail-activity.component.scss']
})
export class UserDetailActivityComponent implements OnInit {

  @Input() userId: number = 0
  public activity_loading: boolean = false;
  public activity: UserActivityLog[] = [];
  public activity_error: boolean = false;

  constructor(
    private userActivityService: UserActivityService
  ) { }

  public async getUserActivity(userId: number) {
    this.activity_error = false;
    try {
      this.activity_loading = true;
      const activity = await this.userActivityService.getForUser(userId);
      this.activity = activity.data;
    } catch (error) {
      this.activity_error = true;
      console.error('Error fetching user activity:', error);
    } finally {
      this.activity_loading = false;
    }
  }

  ngOnInit(): void {
    this.getUserActivity(this.userId);
  }

}
